export enum partTypeEnum {
    headLeft = 'headLeft',
    bodyA = 'bodyA',
    bodyB = 'bodyB',
    corridor = 'corridor',
    headRight = 'headRight',
}